import { Dirary } from '../../types/dirary';

export const useCheckSendable = () => {
  const invalidSiteNames = [
    '製番を入力してください',
    '工程データが見つかりません',
    '受注データが見つかりません',
    '原価確定済です',
  ];

  //全体の入力をチェック
  const checkDiaryListSendable = (
    totalTime: { hour: number; min: number; text: string },
    diaryList: Dirary[],
    deleteDiaryList: Dirary[],
    isOverMaxChain: boolean = false //夜勤2直対応: チェーンが24h超のとき送信不可
  ): number => {
    if (diaryList.length === 0) {
      if (deleteDiaryList.length > 0) return 0;
      return -1;
    }
    //すべての日報が送信可能かチェック
    const isValidDiary = diaryList.every((diary) => diary.isSendable);
    //作業時間の合計が合っているかチェック
    const isValidTotalTimeMin =
      totalTime.min ===
        diaryList.reduce((acc, diary) => acc + diary.workingTimeByMinute, 0) &&
      totalTime.min === diaryList[0].totalWorkingTimeByMinute;

    if (!isValidDiary) return 1; //日報が不正な場合
    if (!isValidTotalTimeMin) return 2; //作業時間が不正な場合
    if (isOverMaxChain) return 3; //チェーンが24時間を超える場合(夜勤2直対応・F5-1)
    return 0;
  };
  //個別の作業日報の入力をチェック
  const checkDiarySendable = (diary: Dirary) => {
    //制作番号
    const isValidProductNo = /^\d{8}$/.test(diary.productNo);
    const isValidProductBno = /^\d{2}$/.test(diary.productBno);
    //工程
    const isValidProcess =
      diary.processId !== '0000' &&
      diary.processName !== '未設定' &&
      diary.slipNumber !== '0000000' &&
      diary.processId !== '' &&
      diary.processName !== '' &&
      diary.slipNumber !== '';
    const productNo = diary.productNo + '-' + diary.productBno;
    const isNoProduction = productNo === '99999999-99';
    //表示名
    const isValidDisplayName =
      (!isNoProduction && diary.displayName.trim() !== '') || isNoProduction;
    //現場名
    const isValidSiteName =
      (!isNoProduction &&
        diary.siteName.trim() !== '' &&
        !invalidSiteNames.includes(diary.siteName)) ||
      isNoProduction;
    //作業時間
    const isValidWorkingTime = diary.workingTimeByMinute >= 10;
    if (!isValidProductNo) return 1;
    if (!isValidProductBno) return 2;
    if (!isValidSiteName) return 3;
    if (!isValidProcess) return 4;
    if (!isValidDisplayName) return 5;
    if (!isValidWorkingTime) return 6;
    return 0;
  };
  return { checkDiaryListSendable, checkDiarySendable };
};
